import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StoreService } from 'src/app/store.service';
import { UtilitiesService } from '../../core/utilities.service';
declare const $: any;

interface Block {
  id: number;
  template_id: number;
  name: string;
  schema: string;
}

interface Data {
  data: string;
}

@Component({
  selector: 'app-store-editor',
  templateUrl: './store-editor.component.html',
  styleUrls: ['./store-editor.component.scss'],
})
export class StoreEditorComponent implements OnInit {
  siteBlocks: Block[] = [];
  dataBlocks: Data[] = [];
  global_template_id: any;
  activeBlockName = '';
  openBlock = true;
  openActiveBlock = false;
  openSettings = true;
  openAddBlock = false;
  menuChanges = false;
  newChanges = false;

  lastLoadedDataSnapshot: string = '';
  dataOutput: string = '';

  block = [true, false, false, false, false, false];
  store_id = 68254431;
  instant_site_link = 'https://shop.estore5s.com/';
  validationError = false;
  errorCount = 0;

  loading = false;
  clickEventsubscription: Subscription;

  constructor(
    private storeService: StoreService,
    private utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    // Change template based on store_id
    const store_id = localStorage.getItem('store_id');
    if (store_id) {
      this.store_id = parseInt(store_id);
    }

    this.loadData();
  }

  loadData() {
    // this.loading = true;

    const template_id = [1001, 1002, 1003];

    this.siteBlocks = [];

    for (let i = 0; i < template_id.length; i++) {
      this.storeService.getTemplateSchema(template_id[i]).subscribe((res) => {
        if (res.code == 'OK') {
          // store template_name and schema_json
          this.siteBlocks.push({
            id: res.data.id,
            template_id: res.data.template_id,
            name: res.data.template_name,
            schema: res.data.schema_json,
          });
          this.siteBlocks.sort(function (a, b) {
            return a.id - b.id || a.name.localeCompare(b.name);
          });

          setTimeout(() => {
            this.loading = false;
          }, 600);
        }
      });
    }
  }

  validateForm() {
    // Form validation
    var inputs = $('.jsonform-required input');
    var labels = $('.jsonform-required label');
    var spans = $('.jsonform-required span');

    let all_input = [];

    for (var i = 0; i < inputs.length; i++) {
      if ($(inputs[i]).val() == '') {
        $(inputs[i]).css('border-color', '#dc3545');
        this.validationError = true;

        // Append input error info
        var label_name = $(labels[i]).html();
        $(spans[i]).html(label_name + ' is required');

        all_input[i] = true;
      } else {
        $(inputs[i]).css('border-color', '#CED4DA');

        // Remove input error info
        var label_name = $(labels[i]).html();
        $(spans[i]).html('');

        all_input[i] = false;
      }
    }

    // Check if all inputs got no error
    let result = all_input.every((v) => v === false);
    if (result) {
      this.validationError = false;
    }
  }

  publish() {
    this.errorCount = 0;
    this.validateForm();

    // Proceed publish if no validation error
    if (!this.validationError) {
      this.storeService
        .updateTemplateData(
          this.dataOutput,
          this.store_id,
          this.global_template_id
        )
        .subscribe((res) => {
          this.loadData();

          // Show toast messsage for success or error
          if (res.code == 'DATA_UPDATED') {
            this.lastLoadedDataSnapshot = this.dataOutput;
            this.checkNewChanges();

            this.utils.notify.showSuccess(
              this.utils.translate('Updated Successfully!')
            );
          } else {
            this.utils.notify.showError(this.utils.translate("Data update failed!"));
          }
        });
    } else {
      this.utils.notify.showError(this.utils.translate("Please fill out required fields!"));
      this.errorCount = 1;
    }
  }

  generateForm(schema: string) {
    this.checkNewChanges();

    // example form
    $('#form').jsonForm({
      schema: {
        name: {
          title: 'Name',
          type: 'string',
        },
        gender: {
          title: 'Gender',
          type: 'string',
          enum: ['male', 'female', 'alien'],
        },
      },
    });
    // example form

    // pass schema json to generate form
    // const formatted_schema = JSON.parse(schema);
    // document.getElementById("form").innerHTML = '';
    // $('#form').jsonForm(formatted_schema);

    // Add listen to update dataJson textarea every time keyup is triggered.
    // This is required to transfer jQuery data to Angular form
    // Before adding event listener, remove the previous listener to prevent duplicate calls
    // $('#form').off('keyup').on('keyup',this.updateDataJsonTextArea)

    // // console.log({formatted_schema});

    // // Get json values from api
    // this.storeService.getTemplateData(this.store_id,this.global_template_id).subscribe(res => {
    //   if(res.code == 'OK' ){

    //     // Capture snapshot for last loaded data (can be hashed if possible)
    //     this.lastLoadedDataSnapshot = res.data.data_json;
    //     console.log('this.lastLoadedDataSnapshot', this.lastLoadedDataSnapshot)

    //     // Check if data_json is array
    //     // If array, remove '[]' so that jsonform library can read it
    //     let data_json;
    //     if(JSON.parse(res.data.data_json).length == 1) {
    //       data_json = res.data.data_json.replace(/[\[\]']+/g,'');
    //     }
    //     else {
    //       data_json = res.data.data_json;
    //     }

    //     // Append data_json into current schema
    //     let a = schema;
    //     let b = ',"value": ' + data_json;
    //     let position = a.length-3;
    //     let output = [a.slice(0, position + 1), b, a.slice(position)].join('');

    //     // Generate new form with values
    //     $('#form').jsonForm(JSON.parse(output));
    //     this.updateDataJsonTextArea();
    //   }
    // })
  }

  toggleBlock(block: string, schema: string, template_id: any) {
    this.openBlock = !this.openBlock;
    this.openActiveBlock = !this.openActiveBlock;
    this.activeBlockName = block;

    if (template_id) {
      this.global_template_id = template_id;

      setTimeout(() => {
        this.generateForm(schema);
      }, 100);
    } else {
      // Empty the output data json
      $('#data-output-textarea').val('');
      this.lastLoadedDataSnapshot = this.dataOutput;
      this.checkNewChanges();
    }

    // if(this.openAddBlock) {
    //   this.openBlock = true;
    //   this.openAddBlock = false;
    //   this.openActiveBlock = false;
    //   this.resetBlock();
    // }

    // if(this.openActiveBlock) {
    //   setTimeout(()=>{
    //     this.generateForm(schema);
    //   },50)
    // }
  }

  toggleSettings() {
    this.openSettings = !this.openSettings;

    // prevent scrolling when settings open
    if (this.openSettings) {
      document.getElementById('section_left').classList.add('stop-scrolling');
    } else {
      document
        .getElementById('section_left')
        .classList.remove('stop-scrolling');
    }
  }

  addBlock() {
    this.openBlock = false;
    this.openAddBlock = true;
    window.scroll(0, 0);
  }

  chooseBlock(id: number, name: string) {
    for (let i = 0; i < this.block.length; i++) {
      this.block[i] = false;
    }
    this.block[id] = true;

    for (let i = 0; i < 6; i++) {
      if (id == i) {
        document
          .getElementById(name)
          .scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
      }
    }
  }

  resetBlock() {
    for (let i = 0; i < this.block.length; i++) {
      this.block[i] = false;
    }
    this.block[0] = true;
  }

  close() {
    if (this.openSettings) this.openSettings = false;
    if (this.openAddBlock) this.openAddBlock = false;
    if (this.menuChanges) this.menuChanges = false;
  }

  discardChanges() {
    console.log('DISCARD CHANGES CLICKED');
    this.dataOutput = this.lastLoadedDataSnapshot;
    $('#data-output-textarea').val('');
    this.updateDataJsonTextArea();
    this.checkNewChanges();

    if (!this.openBlock) {
      this.toggleBlock('', '', '');
    }
  }

  updateDataJsonTextArea() {
    // var formData = $('#form').jsonFormValue();
    // // Update data-output-textarea value and dispatchEvent to trigger our custom dataJsonUpdate event for Angular
    // $('#data-output-textarea').val(JSON.stringify(formData))
    // $('#data-output-textarea').get(0).dispatchEvent(new Event('dataJsonUpdate'))
  }

  handleDataJsonUpdate($event) {
    this.dataOutput = $event.target.value;
    console.log('handleDataJsonUpdate::', this.dataOutput);

    this.sendDataToStorePreview();
    this.checkNewChanges();

    if (this.errorCount == 1) {
      this.validateForm();
    }
  }

  // Send postMessage to preview store iframe.
  // This will allow store to instantly render our changes from editor
  sendDataToStorePreview() {
    console.log(this.dataOutput);
    let encodedFormData = btoa(this.dataOutput);
    console.log('SENDING MSG TO PREVIEW STORE:: ', { encodedFormData });

    // $('#editor-preview').get(0).contentWindow.postMessage(encodedFormData,'*')
  }

  checkNewChanges() {
    // Check if there is differences between last loaded data snapshot and current data
    if (
      this.lastLoadedDataSnapshot.toLowerCase() ===
      this.dataOutput.toLowerCase()
    ) {
      this.newChanges = false;
    } else {
      this.newChanges = true;
    }

    // if(this.lastLoadedDataSnapshot.toLowerCase() !== this.oldData.toLowerCase()) {
    //   this.newChanges = true;
    // }
  }

  // get newChanges(){
  //   // Check if there is differences between last loaded data snapshot and current data
  //   let currentDataJSON = JSON.stringify(this.dataOutput);
  //   return !((this.lastLoadedDataSnapshot || '').toLowerCase() === (currentDataJSON || '').toLowerCase());
  // }
}
